module.exports = __webpack_public_path__ + "img/Main_logo.3c75b276.png";